import { useAuth0 } from '@auth0/auth0-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteChat } from '../apis/chatApi';

export const useDeleteChat = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (chatId: string) => {
      const token = await getAccessTokenSilently();
      return deleteChat(chatId, token);
    },
    onSuccess: (_data, chatId) => {
      // Remove deleted chat from cache immediately to avoid flash
      queryClient.setQueryData(['chats'], (old: unknown) =>
        Array.isArray(old) ? old.filter((c: { id: string }) => c.id !== chatId) : old
      );
      queryClient.invalidateQueries({ queryKey: ['chats'] });
    },
    onError: (error) => {
      console.error('Error deleting chat:', error);
    },
  });

  return {
    deleteChat: mutation.mutateAsync,
    isDeleting: mutation.isPending,
    error: mutation.error,
  };
};